/**
 * Created by floriangref on 20.06.16.
 */
(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('PartService', PartService);

    PartService.$inject = ['$http', 'API_URL'];

    function PartService($http, API_URL) {
        var service = {
            loadPartsForCategory: loadPartsForCategory,
            loadDocumentsForCategory: loadDocumentsForCategory,
            loadExternalLinksForCategory: loadExternalLinksForCategory,
            loadAreas: loadAreas,
            loadParkingPermits: loadParkingPermits,
            loadExhibitorPermits: loadExhibitorPermits
        };

        return service;

        function loadParkingPermits(tempExhibitors) {
            return $http.get(API_URL + 'parts/parkingpermits', {params: {tempExhibitors: tempExhibitors}});
        }

        function loadExhibitorPermits(tempExhibitors) {
            return $http.get(API_URL + 'parts/exhibitorpermits', {params: {tempExhibitors: tempExhibitors}});
        }

        function loadPartsForCategory(category) {
            return $http.get(API_URL + 'parts/category', {params: {category: category}});
        }

        function loadDocumentsForCategory(category) {
            return $http.get(API_URL + 'parts/documents', {params: {category: category}});
        }

        function loadExternalLinksForCategory(category) {
            return $http.get(API_URL + 'parts/external-links', {params: {category: category}});
        }

        function loadAreas() {
            return $http.get(API_URL + 'area/booked');
        }
    }
})();
